/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import JsBarcode from 'jsbarcode';
import type { TDocumentDefinitions, Content } from 'pdfmake/interfaces';

interface Iitens {
  qtds: number;
  un: string;
  preco: number;
  subtotal: number;
  total: number;
  localizado?: string;
  referencia?: string;
  filtro: string;
  descricao: string;
}

interface IEmpresa {
  nome: string;
  fantasia?: string;
  cnpj?: string;
  ie?: string;
  endereco?: string;
  numero?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  cep?: string;
  telefone?: string;
  logo?: string;
}

interface IgetImpressao {
  idmov: string;
  dataoperacao: string;
  numero: string;
  total: number;
  vprod: number;
  desconto: number;
  acrescimo: number;
  cidade?: string;
  uf?: string;
  vendedor?: string;
  celular?: string;
  cep?: string;
  nome?: string;
  endereco?: string;
  obs?: string;

  itens: Iitens[];
  empresa: IEmpresa[];
}

const getBase64FromUrl = async (url: string): Promise<string | null> => {
  try {
    if (!url || url === '') {
      return null;
    }

    const response = await fetch(url, {
      mode: 'cors',
      cache: 'no-cache'
    });

    if (!response.ok) {
      console.error('Erro ao carregar imagem:', response.status, response.statusText);
      return null;
    }

    const blob = await response.blob();

    if (!blob.type.startsWith('image/')) {
      console.error('O arquivo não é uma imagem válida:', blob.type);
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const result = reader.result as string;
        if (result && result.startsWith('data:image')) {
          resolve(result);
        } else {
          reject(new Error('Formato de imagem inválido'));
        }
      };

      reader.onerror = () => {
        reject(new Error('Erro ao ler o arquivo'));
      };

      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Erro ao carregar logo:', error);
    return null;
  }
};

// Função para ajustar as dimensões da logo mantendo a proporção
const ajustarDimensoesLogo = async (logoBase64: string, maxWidth: number, maxHeight: number): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const proporcao = img.width / img.height;
      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        width = maxWidth;
        height = width / proporcao;
      }

      if (height > maxHeight) {
        height = maxHeight;
        width = height * proporcao;
      }

      resolve({ width, height });
    };
    img.onerror = () => {
      resolve({ width: 70, height: 50 });
    };
    img.src = logoBase64;
  });
};

async function PDFORCAMENTO(dados: IgetImpressao): Promise<Blob> {

  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf',
    },
  };

  if (pdfFonts?.pdfMake?.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  const empresa = dados.empresa?.[0];

  let logoBase64: string | null = null;
  let logoDimensoes = { width: 70, height: 50 };

  if (empresa?.logo) {
    try {
      const baseUrl = window.env?.REACT_APP_URL_IMGLOG || '';
      const url = `${baseUrl}${empresa.logo}`;

      logoBase64 = await getBase64FromUrl(url);

      if (logoBase64) {
        logoDimensoes = await ajustarDimensoesLogo(logoBase64, 70, 55);
      }
    } catch (error) {
      console.error('Erro ao carregar logo:', error);
      logoBase64 = null;
    }
  }

  const gerarCodigoBarras = (texto: string) => {
    try {
      const canvas = document.createElement('canvas');

      JsBarcode(canvas, texto, {
        format: 'CODE128',
        height: 35,
        width: 1.5,
        displayValue: false,
      });

      return canvas.toDataURL('image/png');
    } catch (error) {
      console.error('Erro ao gerar código de barras:', error);
      const canvas = document.createElement('canvas');
      canvas.width = 170;
      canvas.height = 35;
      return canvas.toDataURL('image/png');
    }
  };

  const codigoBarras = gerarCodigoBarras(dados.idmov);

  const LIMITE_ITENS = 10;
  const ALTURA_FIXA_ITENS = 160;
  const paginas: Iitens[][] = [];

  for (let i = 0; i < dados.itens.length; i += LIMITE_ITENS) {
    paginas.push(dados.itens.slice(i, i + LIMITE_ITENS));
  }

  const content: Content[] = [];

  paginas.forEach((itensPagina, index) => {

    const linhasItens = itensPagina.map((item, idx) => [
      {
        text: Number(item.qtds).toLocaleString('pt-BR', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 3,
        }),
        fontSize: 7,
        alignment: 'left' as const,
        margin: [0, idx === itensPagina.length - 1 ? 0 : 2, 0, 0]
      },
      {
        text: item.descricao || '-',
        fontSize: 7,
        margin: [0, idx === itensPagina.length - 1 ? 0 : 2, 0, 0]
      },
      {
        text: item.referencia || '-',
        fontSize: 7,
        margin: [0, idx === itensPagina.length - 1 ? 0 : 2, 0, 0]
      },
      {
        text: item.un || 'UN',
        fontSize: 7,
        alignment: 'left' as const,
        margin: [0, idx === itensPagina.length - 1 ? 0 : 2, 0, 0]
      },
      {
        text: item.localizado || '-',
        fontSize: 7,
        margin: [0, idx === itensPagina.length - 1 ? 0 : 2, 0, 0]
      },
      {
        text: item.preco.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
        fontSize: 7,
        alignment: 'right' as const,
        margin: [0, idx === itensPagina.length - 1 ? 0 : 2, 0, 0]
      },
      {
        text: item.subtotal.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
        fontSize: 7,
        alignment: 'right' as const,
        margin: [0, idx === itensPagina.length - 1 ? 0 : 2, 0, 0]
      },
    ]);

    // DADOS DO CLIENTE - COM BORDA COMPLETA
    content.push({
      margin: [0, -50, 0, 0],
      table: {
        widths: ['*'],
        body: [
          [
            {
              stack: [
                {
                  columns: [
                    {
                      width: '*',
                      stack: [
                        {
                          text: [
                            { text: 'CLIENTE: ', bold: true, fontSize: 8, color: '#000000' },
                            { text: dados.nome || '-', fontSize: 10, color: '#000000' }
                          ],
                          margin: [0, 1, 0, 1],
                        },
                        {
                          text: [
                            { text: 'ENDEREÇO: ', bold: true, fontSize: 8, color: '#000000' },
                            { text: dados.endereco || '-', fontSize: 8, color: '#000000' }
                          ],
                          margin: [0, 1, 0, 1],
                        },
                        {
                          text: [
                            { text: 'CIDADE: ', bold: true, fontSize: 8, color: '#000000' },
                            { text: `${dados.cidade || '-'} / ${dados.uf || ''}`, fontSize: 8, color: '#000000' }
                          ],
                          margin: [0, 1, 0, 1],
                        },
                      ],
                    },
                    {
                      width: 180,
                      stack: [
                        {
                          text: [
                            { text: 'CELULAR: ', bold: true, fontSize: 8, color: '#000000' },
                            { text: dados.celular || '-', fontSize: 8, color: '#000000' }
                          ],
                          margin: [0, 1, 0, 1],
                        },
                        {
                          text: [
                            { text: 'CEP: ', bold: true, fontSize: 8, color: '#000000' },
                            { text: dados.cep || '-', fontSize: 8, color: '#000000' }
                          ],
                          margin: [0, 1, 0, 1],
                        },
                        {
                          text: [
                            { text: 'VENDEDOR: ', bold: true, fontSize: 8, color: '#000000' },
                            { text: dados.vendedor || 'Não informado', fontSize: 9, color: '#000000' }
                          ],
                          margin: [0, 1, 0, 1],
                        },

                      ],
                    },
                  ],
                },
              ],
              margin: [6, 4, 6, 4],
              border: [true, true, true, true],
              fillColor: '#f8f9fa',
            },
          ],
        ],
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        hLineColor: () => '#2c3e50',
        vLineColor: () => '#2c3e50',
      },
    });

    content.push({
      table: {
        widths: ['*'],
        heights: [ALTURA_FIXA_ITENS],
        body: [
          [
            {
              table: {
                headerRows: 1,
                widths: [25, '*', 70, 30, 30, 40, 40],
                body: [
                  [
                    {
                      text: 'QTD',
                      bold: true,
                      fontSize: 7,
                      fillColor: '#f0f0f0',
                      color: '#000000',
                      alignment: 'left' as const,
                      margin: [4, 3, 4, 3],
                    },
                    {
                      text: 'DESCRIÇÃO DO PRODUTO',
                      bold: true,
                      fontSize: 7,
                      fillColor: '#f0f0f0',
                      color: '#000000',
                      margin: [4, 3, 4, 3],
                    },
                    {
                      text: 'REFERÊNCIA',
                      bold: true,
                      fontSize: 7,
                      fillColor: '#f0f0f0',
                      color: '#000000',
                      alignment: 'left' as const,
                      margin: [4, 3, 4, 3],
                    },
                    {
                      text: 'UN',
                      bold: true,
                      fontSize: 7,
                      fillColor: '#f0f0f0',
                      color: '#000000',
                      alignment: 'left' as const,
                      margin: [4, 3, 4, 3],
                    },
                    {
                      text: 'Local',
                      bold: true,
                      fontSize: 7,
                      fillColor: '#f0f0f0',
                      color: '#000000',
                      alignment: 'left' as const,
                      margin: [4, 3, 4, 3],
                    },
                    {
                      text: 'PREÇO',
                      bold: true,
                      fontSize: 7,
                      fillColor: '#f0f0f0',
                      color: '#000000',
                      alignment: 'right' as const,
                      margin: [4, 3, 4, 3],
                    },
                    {
                      text: 'TOTAL',
                      bold: true,
                      fontSize: 7,
                      fillColor: '#f0f0f0',
                      color: '#000000',
                      alignment: 'right' as const,
                      margin: [4, 3, 4, 3],
                    },
                  ],
                  ...linhasItens,
                ],
              },
              layout: {
                hLineWidth: (i: number, node: { table: { body: unknown[] } }) => {
                  if (i === 0 || i === node.table.body.length) return 0.5;
                  return 0.3;
                },
                vLineWidth: () => 0.3,
                hLineColor: () => '#ccc',
                vLineColor: () => '#ccc',
                fillColor: (i: number) => {
                  if (i === 0) return '#f0f0f0';
                  return i % 2 === 0 ? '#ffffff' : '#fafafa';
                },
              },
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [0, 0, 0, 8],
    });

    // LINHA SUPERIOR
    content.push({
      canvas: [
        {
          type: 'line' as const,
          x1: 0,
          y1: 0,
          x2: 560,
          y2: 0,
          lineWidth: 0.6,
          lineColor: '#000000',
        },
      ],
      margin: [0, -2, 0, 6],
    });

    // TOTAIS
    content.push({
      columns: [
        {
          text: `Valor Produtos: ${dados.vprod.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 9,
        },
        {
          text: `Acréscimo: ${(dados.acrescimo || 0).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 9,
          alignment: 'center',
        },
        {
          text: `Desconto: ${(dados.desconto || 0).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 9,
          alignment: 'center',
        },
        {
          text: `Total: ${dados.total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })}`,
          fontSize: 9,
          bold: true,
          alignment: 'right',
        },
      ],
      margin: [0, -2, 0, 4],
    });

    // LINHA INFERIOR
    content.push({
      canvas: [
        {
          type: 'line' as const,
          x1: 0,
          y1: 0,
          x2: 560,
          y2: 0,
          lineWidth: 0.6,
          lineColor: '#000000',
        },
      ],
      margin: [0, 0, 0, 8],
    });

    content.push({
      columns: [
        {
          width: '*',
          stack: [
            {
              text: [
                { text: 'Obs: ', bold: true, fontSize: 9, color: '#000000' },
                { text: dados.obs || '', fontSize: 9, color: '#000000' }
              ],
              margin: [0, 0, 0, 2],
            },
          ],
        },
        {
          width: 'auto',
          stack: [
            {
              text: `Pg ${index + 1} de ${paginas.length}`,
              alignment: 'right' as const,
              fontSize: 8,
              color: '#020202',
              margin: [0, 0, 0, 2],
            },
          ],
        },
      ],
      margin: [0, 0, 0, 30],
    });
    // ASSINATURA
    content.push({
      margin: [0, -10, 0, 5],
      stack: [
        {
          canvas: [
            {
              type: 'line' as const,
              x1: 180,
              y1: 0,
              x2: 380,
              y2: 0,
              lineWidth: 0.8,
              lineColor: '#2c3e50',
            },
          ],
        },
        {
          text: 'Assinatura do Cliente',
          alignment: 'center' as const,
          italics: true,
          fontSize: 8,
          color: '#7f8c8d',
          margin: [0, 9, 0, 0],
        },
      ],
    });

    // CÓDIGO DE BARRAS
    content.push({
      image: codigoBarras,
      width: 160,
      alignment: 'center' as const,
      margin: [0, -3, 0, 0],
    });

    // Quebra de página
    if (index < paginas.length - 1) {
      content.push({
        text: '',
        pageBreak: 'after' as const
      });
    }
  });

  const documentDefinition: TDocumentDefinitions = {
    pageSize: 'A4',
    pageMargins: [25, 120, 25, 20],

    header: (currentPage, pageCount) => ({
      margin: [25, 0, 25, 12],
      table: {
        widths: ['*'],
        body: [
          [
            {
              border: [true, true, true, true],
              borderColor: '#050606',
              borderWidth: 1,
              margin: [8, 8, 8, 8],
              stack: [
                {
                  columns: [
                    {
                      width: 75,
                      alignment: 'center',
                      stack: [
                        logoBase64 && logoBase64.startsWith('data:image')
                          ? {
                            image: logoBase64,
                            width: logoDimensoes.width,
                            height: logoDimensoes.height,
                            alignment: 'center' as const,
                            margin: [8, 8, 8, 8],
                          }
                          : {
                            text: 'LOGO',
                            alignment: 'center' as const,
                            margin: [0, 25, 0, 25],
                            fontSize: 9,
                            color: '#999',
                            bold: true,
                          },
                      ],
                    },
                    {
                      width: '*',
                      stack: [
                        {
                          text: empresa?.fantasia || empresa?.nome || '',
                          bold: true,
                          fontSize: 13,
                          alignment: 'center' as const,
                          color: '#2c3e50',
                          margin: [0, 8, 0, 4],
                        },
                        {
                          text: `${empresa?.endereco || ''}, ${empresa?.numero || ''} - ${empresa?.bairro || ''} - ${empresa?.cidade || ''} - ${empresa?.uf || ''}`,
                          alignment: 'center' as const,
                          fontSize: 8,
                          color: '#454545',
                          margin: [0, 0, 0, 2],
                        },
                        {
                          text: `Tel: ${empresa?.telefone || ''}`,
                          alignment: 'center' as const,
                          fontSize: 8,
                          color: '#454545',
                          margin: [0, 0, 0, 2],
                        },
                        {
                          text: '• NÃO É DOCUMENTO FISCAL •',
                          alignment: 'center' as const,
                          bold: true,
                          fontSize: 7,
                          color: '#050404',
                          margin: [0, 0, 0, 8],
                        },
                      ],
                    },
                    {
                      width: 120,
                      stack: [
                        {
                          text: 'ORÇAMENTO',
                          bold: true,
                          fontSize: 12,
                          alignment: 'center' as const,
                          color: '#2c3e50',
                          margin: [0, 8, 0, 5],
                        },
                        {
                          text: `Nº ${dados.numero}`,
                          alignment: 'center' as const,
                          bold: true,
                          fontSize: 10,
                          color: '#040608',
                          margin: [0, 1, 0, 5],
                        },
                        {
                          text: moment(dados.dataoperacao).format('DD/MM/YYYY HH:mm:ss'),
                          alignment: 'center' as const,
                          fontSize: 9,
                          color: '#1a1d1d',
                          margin: [0, 1, 0, 3],
                        },

                      ],
                    },
                  ],
                },
              ],
            },
          ],
        ],
      },
      layout: {
        hLineWidth: () => 0,
        vLineWidth: () => 0,
      },
    }),

    content,

    defaultStyle: {
      font: 'Roboto',
    },
  };

  return new Promise((resolve, reject) => {
    try {
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
      pdfDocGenerator.getBlob((blob) => {
        resolve(blob);
      });
    } catch (error) {
      reject(error);
    }
  });
}

export default PDFORCAMENTO;